import { PureComponent } from 'react'
import _ from 'lodash'
import { getNumberWithChineseUnit } from '../../../../../../lib/renderUtil'

class YAxisTick extends PureComponent {
  render () {
    const { x, y, payload, textAnchor, customizeTickValue = v => v } = this.props
    const value = _.get(payload, 'value', 0)

    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={4}
          textAnchor={textAnchor}
          fill='#979ba7'
          fontSize='12'
        >
          {getNumberWithChineseUnit(value, customizeTickValue)}
        </text>
      </g>
    )
  }
}

export default YAxisTick
